import { type KeyPhraseNodeType } from '../api/useAutohighlightSupplier';

export const getHighlightCategories: (nodes: KeyPhraseNodeType[]) =>
	| {
			[k: string]: number;
	  }
	| undefined = (nodes: KeyPhraseNodeType[]) => {
	const categories = new Map<string, number>();
	try {
		nodes.forEach((node) => {
			const curCategoryCount = categories.get(node.category);
			if (!!curCategoryCount) {
				categories.set(node.category, curCategoryCount + 1);
			} else {
				categories.set(node.category, 1);
			}
		});
	} catch {
		return undefined;
	}
	return Object.fromEntries(categories);
};
